import {
  BillingAccount,
  BillingInvoice,
  DailyBox,
  DebtorAccount,
  InvoiceStatus,
  IssueInvoiceDto,
  PaymentReceipt,
  RecordPaymentDto,
  RecordPaymentResponse,
} from 'types/models';
import apiClient from './apiClient';

export const billingService = {
  getAccountByPatient: async (patientId: string): Promise<BillingAccount> => {
    const { data } = await apiClient.get<BillingAccount>(
      `/payments/billing-accounts/${patientId}`,
    );
    return data;
  },

  recordPayment: async (patientId: string, payload: RecordPaymentDto): Promise<RecordPaymentResponse> => {
    const { data } = await apiClient.post<RecordPaymentResponse>(
      `/payments/billing-accounts/${patientId}/record-payment`,
      payload,
    );
    return data;
  },

  getReceipts: async (patientId: string): Promise<PaymentReceipt[]> => {
    const { data } = await apiClient.get<PaymentReceipt[]>(
      `/payments/billing-accounts/${patientId}/receipts`,
    );
    return data;
  },

  getAccountsWithDebt: async (): Promise<DebtorAccount[]> => {
    const { data } = await apiClient.get<DebtorAccount[]>('/payments/ar/accounts-with-debt');
    return data;
  },

  getDailyBox: async (): Promise<DailyBox> => {
    const { data } = await apiClient.get<DailyBox>('/payments/my-daily-box');
    return data;
  },

  closeShift: async (): Promise<Blob> => {
    const { data } = await apiClient.post('/payments/my-daily-box/close-shift', {}, {
      responseType: 'blob',
    });
    return data as Blob;
  },

  // ─── Facturación Electrónica ────────────────────────────────────────────────

  listInvoices: async (status?: InvoiceStatus): Promise<BillingInvoice[]> => {
    const params = status ? { status } : {};
    const { data } = await apiClient.get<BillingInvoice[]>('/payments/invoices', { params });
    return data;
  },

  listInvoicesByPatient: async (patientId: string): Promise<BillingInvoice[]> => {
    const { data } = await apiClient.get<BillingInvoice[]>(
      `/payments/billing-accounts/${patientId}/invoices`,
    );
    return data;
  },

  issueInvoice: async (patientId: string, dto: IssueInvoiceDto): Promise<BillingInvoice> => {
    const { data } = await apiClient.post<BillingInvoice>(
      `/payments/billing-accounts/${patientId}/invoices/issue`,
      dto,
    );
    return data;
  },

  authorizeInvoice: async (invoiceId: string): Promise<BillingInvoice> => {
    const { data } = await apiClient.post<BillingInvoice>(
      `/payments/invoices/${invoiceId}/authorize`,
      {},
    );
    return data;
  },

  voidInvoice: async (invoiceId: string): Promise<BillingInvoice> => {
    const { data } = await apiClient.put<BillingInvoice>(
      `/payments/invoices/${invoiceId}/void`,
    );
    return data;
  },

  downloadInvoicePdf: async (invoiceId: string): Promise<Blob> => {
    const { data } = await apiClient.get(`/payments/invoices/${invoiceId}/pdf`, {
      responseType: 'blob',
    });
    return data as Blob;
  },

  downloadInvoiceXml: async (invoiceId: string): Promise<Blob> => {
    const { data } = await apiClient.get(`/payments/invoices/${invoiceId}/xml`, {
      responseType: 'blob',
    });
    return data as Blob;
  },
};
